// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__GUhOJ","footer":"ModalError_footer__nMK1_"};